import React from "react";
import {
  CellProps,
  SortableCell as TableSortableCell,
} from "@sonder/ui/source/styled/fragments/Table";
import { useSegment } from "analytics/segment";
import { setSortOptions } from "checkouts/actions";
import { useStore } from "checkouts/store";
import { mapGQLSortToSortOrder } from "core/utils/mapGQLSortToSortOrder";
import {
  InquiryCheckoutSortColumn,
  InquiryCheckoutSortInput,
  SortAscDesc,
} from "typings/globalGQLTypes";

// Helpers
const createSegmentEvent = (
  sort: InquiryCheckoutSortInput[],
): SegmentEvent => ({
  eventName: "checkouts_view",
  action: "click",
  element: "sortable_column_header",
  commonProps: {
    sort: sort.map(({ column, order }) => `${column}-${order}`),
  },
});

// Exports
interface SortableCellProps extends CellProps {
  sortKey: InquiryCheckoutSortColumn;
}
export const SortableCell = ({
  children,
  sortKey,
  ...cellProps
}: SortableCellProps) => {
  const {
    state: { sort },
    dispatch,
  } = useStore();
  const { track } = useSegment();
  const currentSort: InquiryCheckoutSortInput | undefined = sort[0];

  const sortOrder = mapGQLSortToSortOrder(
    currentSort && currentSort.column === sortKey
      ? currentSort.order
      : undefined,
  );

  const onUpdateSource = (nextSort: InquiryCheckoutSortInput | null) => {
    const sortArr = nextSort ? [nextSort] : [];
    track(createSegmentEvent(sortArr));
    dispatch(setSortOptions(sortArr));
  };

  return (
    <TableSortableCell
      {...cellProps}
      sortOrder={sortOrder}
      onClick={() => {
        // Start sorting by this key
        // Set sort order: null => asc
        if (sortOrder === null)
          onUpdateSource({
            column: sortKey,
            order: SortAscDesc.asc,
          });
        // Flip sort order: asc => desc
        else if (sortOrder === "asc")
          onUpdateSource({
            column: currentSort.column,
            order: SortAscDesc.desc,
          });
        // Reset sort order: desc => null
        else onUpdateSource(null);
      }}
    >
      {children}
    </TableSortableCell>
  );
};
